import React, { useState, useEffect, useContext } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import Tooltip from '@mui/material/Tooltip';
import { Button, Switch, FormControlLabel } from "@mui/material";
import NewUserDialog from './components/NewUserDialog';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import './UserList.css'
import NotificationManager from 'react-notifications/lib/NotificationManager';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../../contexts/authContext';
import axios  from 'axios';

import CircleProgress  from "../../../components/CircleProgress/CircleProgress";
import NoRowsDataGridComponent from '../../../components/NoRowsDataGridComponent/NoRowsDataGridComponent';

import { Dialog 
        ,DialogActions 
        ,DialogContent 
        ,DialogContentText 
        ,DialogTitle
        ,TextField } from '@mui/material';
import config from '../../../config';
import configMessage from '../../../utils/configMessage.json';

import {
	DataGridPremium,
	LicenseInfo
} from '@mui/x-data-grid-premium';
//import { LicenseInfo } from '@mui/x-license';

LicenseInfo.setLicenseKey(config.DATAGRID_LICENSE);

function UserList() {
	const navigate = useNavigate();
    const auth = useContext(AuthContext);

    const [loading, setLoading] = useState(true);
	const [users,      setUsers                  ] = useState([]);
	const [sTempUsers, setsTempUsers             ] = useState('');
	const [aTempUsers, setaTempUsers             ] = useState([]);
	const [paramsDel,  setParamsDel              ] = useState([]);
	const [enabledUsers,     setEnabledUsers     ] = useState(true);

	const getRowId = (row) => row.KUSER;

	const [openDialogDelete, setOpenDialogDelete] = useState(false);

	const columns = [
	{
		field: ' ', headerClassName: 'header-cell ', headerName: " ", width: 60, resizable: false, sortable: false, editable: false,
		renderCell: (params) =>
		(<>
			<IconButton title='Edit User' className="action-cell" onClick={() => navigate(`/users/account-details/${params.id}`)}>
				<EditIcon />
			</IconButton>
		</>)
		},
		{ field: 'KUSER', headerName: "User ID", type: 'text', width: 80, editable: false, align: 'center' },
		{ field: 'USERNAME', headerClassName: 'header-cell', headerName: "Username", type: 'text', width: 250, editable: false },
		{ field: 'COGNOME', headerClassName: 'header-cell', headerName: "Surname", type: 'text', width: 125, editable: false },
		{ field: 'NOME', headerClassName: 'header-cell', headerName: "Name", type: 'text', width: 125, editable: false },
		{ field: 'EMAIL_ADDRESS', headerClassName: 'header-cell', headerName: "E-Mail", type: 'mail', width: 300, editable: false },
		{ field: 'AGENTE_COD', headerClassName: 'header-cell', headerName: "Sales Rep. Code", type: 'text', width: 180, editable: false },
		{ field: 'FLAG_ADMIN', headerClassName: 'header-cell', headerName: "Admin", type: 'text', width: 70, align: 'center', headerAlign: 'center', sortable: false, editable: false, renderCell: (params) => (params.value === 'N' ? '' : <i className="fa-solid fa-check"></i>) },
		{ field: 'FLAG_ENABLED', headerClassName: 'header-cell', headerName: "Enabled", type: 'text', width: 80, align: 'center', headerAlign: 'center', sortable: false, editable: false, renderCell: (params) => (params.value === 'N' ? '' : <i className="fa-solid fa-check"></i>) }
	];
	
	useEffect(() => {
		getUserList();
	}, [enabledUsers])
  
	useEffect(() => {
		if (enabledUsers === true) {
			const filteredUsers = users.filter(user => user.FLAG_ATTIVO !== 'N');
			setUsers(filteredUsers);
		}
	}, [enabledUsers]);
  
	const modUserRoles = async (cellParams) => {
  
		const formatRoleCodeListOnAdd = (cellParams) => {
			let arrRoles = cellParams.row.ROLE_LIST.split(',');
			arrRoles.push(cellParams.colDef.roleCode.toString());
			let newRoleList = arrRoles.join(',');
			if (newRoleList.startsWith(',')) {
				newRoleList = newRoleList.substring(1);
			}
			return newRoleList;
		}
	
		let params = {
			userId: cellParams.row.KUSER,
			username: cellParams.row.USERNAME,
			nome: cellParams.row.NOME,
			cognome: cellParams.row.COGNOME,
			eMailAddress: cellParams.row.EMAIL_ADDRESS,
			pAgenteCod: cellParams.row.AGENTE_COD,
			flagDoppioProfilo: cellParams.row.FLAG_DOPPIO_PROFILO,
			flagAdmin: cellParams.row.FLAG_ADMIN,
			pRoleCodesList: cellParams.row.ROLE_LIST.split(',').some(code => code === (cellParams.value ? cellParams.value.toString() : null))
			? cellParams.row.ROLE_LIST.split(',').filter(code => code !== cellParams.value.toString()).join(',')
			: formatRoleCodeListOnAdd(cellParams)
		}
		try {

			let axiosParams = {
				url: '/users/user-mod',
				method: 'post',
				params
			}
			//PNUSCG cambiare params in data
			await axios(axiosParams);
			getUserList();
		} catch (error) {
			NotificationManager.error(config.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
		}
	}
  
	const getUserList = async () => {
		const flagSoloAttivi = enabledUsers ? 'Y' : 'N';
	
		const params = {
			flagSoloAttivi: flagSoloAttivi,
		};
	
		try {
			let response = await axios({
				url: '/users/user-list',
				method: 'get',
				baseURL: config.API_URL,
				headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`},				
				params
			});
            
            let data = response?.data || { users: []};

			setUsers(data);
			setaTempUsers(data);

		} catch (error) {
            NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
			console.error('error userlist', error);
		}
        setLoading(false)
	};
  
    const handleFilterUserList = (evt) => {
        const user = evt.target.value;
        setsTempUsers(user);
        const aTemp = users.filter( o => (`${o.COGNOME} ${o.NOME} ${o.EMAIL_ADDRESS} ${o.USERNAME}`).toLowerCase().includes(user.toLowerCase())) || [];
        setaTempUsers(aTemp);
    }
  
	const handleChangeEnabledUsers = (event) => {
		setEnabledUsers(!enabledUsers);
	}

	const [openModal, setOpenModal] = useState(false);
	// const [openModalDelete, setOpenModalDelete] = useState(false);
  
	const handleOpenModal = () => {
		setOpenModal(true);
	};
  
	const handleCloseModal = () => {
		setOpenModal(false);
	};
  
	// const openModalDel = (params) => {
	// 	setOpenModalDelete(true);
	// 	setParamsDel(params.row);
	// 	// setParamsDelSurname(params.row.COGNOME);
	// };
  
	// const closeModalDel = () => {
	//   	setOpenModalDelete(false);
	// };

	const handleOpenDialogDelete = (params) => {
		setOpenDialogDelete(true);
		setParamsDel(params.row);
	}

	const handleCloseDialogDelete = () => {
		setOpenDialogDelete(false);
	}
  
	return (
        <div className='component-container home'>
			<div className='component-card'>
				
        <div className='user-list'>
          { loading ? <CircleProgress /> : <>
			<div className='control-bar'>
				<span className="button-left">
                    <FormControlLabel
                        control={
                            <Switch
                                name="enabledUsers"
                                checked={enabledUsers}
                                onChange={handleChangeEnabledUsers}
                                color="primary"
                            />
                        }
                        label="Enabled Users only"
                    />
                    <TextField label="Search User" placeholder='Search User' value={sTempUsers} onChange={handleFilterUserList} className='' variant='standard' />
				</span>

				<span className="button">
					<Tooltip title="New User">
						<Fab className='bg-primary' size="small" onClick={handleOpenModal}>
							<AddIcon/>
						</Fab>
					</Tooltip>
				</span>
			</div>
  
			<DataGridPremium
				slots={{
					noRowsOverlay: NoRowsDataGridComponent,
				}}
				rows={aTempUsers}
				columns={columns}
				pinnedColumns={{ left: [' ', 'KUSER', 'USERNAME'], right: [] }}
				rowHeight={30}
				hideFooter={true}
				disableColumnMenu={true}
				disableColumnReorder={true}
				getRowId={getRowId}
				className='usersDataGrid'
				getRowClassName={(params) =>
				params.row.FLAG_ATTIVO === 'N' ? 'redRow' : ''
				}
			/>
			
			{
			<NewUserDialog
				isOpen={openModal}
				onClose={handleCloseModal}
				callUser={getUserList}
			/>
			}
	

			</>}
        </div>
		</div>
		</div>
    );
}

export default UserList;